var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('v-card',{staticClass:"px-3",staticStyle:{"background":"#232323"},attrs:{"dark":""}},[_c('span',{staticStyle:{"text-align":"justify"},domProps:{"innerHTML":_vm._s(_vm.philosophy.content)}})])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }